import autosize from 'autosize';

ko.bindingHandlers.autosize = {
    init: (element, valueAccessor) => {
        autosize(element);

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            autosize.destroy(element);
        });
    },
    update: (element, valueAccessor) => {
        valueAccessor();

        autosize.update(element);
    }
}